import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonLink from '../../Form/ButtonLink';

const CardProfileAddresses = () => {
  const navigate = useNavigate();
  return (
    <div className='flex flex-col gap-2 w-full h-full'>
      <h4 className='font-semibold'>Endereços</h4>
      <div className='flex flex-col h-full gap-2'>
        <div className='w-full h-5 bg-gray-100 rounded-md'></div>
        <div className='w-full h-5 bg-gray-100 rounded-md'></div>
      </div>
      <div className='flex justify-between'>
        <ButtonLink disabled onClick={() => navigate('/perfil/meus-enderecos')} className="text-xs">Ver meus endereços</ButtonLink>
      </div>
    </div>
  )
}

export default CardProfileAddresses;